import Vue from "vue";

// Empty Vue instance to carry events between other decoupled instances
const EventBus = new Vue();
export default EventBus;



// WEBPACK FOOTER //
// ./src/frontend/common/image-viewer/event-bus.js